jQuery(function($) {
    $('html').removeClass('pre-jquery');
    $('html').addClass('jquery');
});